import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Row} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {getAllFacility} from "app/entities/healthcare-facility/healthcare-facility.reducer";
import {IRootState} from 'app/shared/reducers';
import {getEntity} from './driver.reducer';
import {getEntities as getVillages} from "app/entities/village/village.reducer";
import {getVillageName} from "app/entities/village/village";
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { useTranslation } from 'app/shared/util/translation-utils';

export interface IDriverDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const DriverDetail = (props: IDriverDetailProps) => {
  const { t } = useTranslation();
  const { villages, currentLocale } = props;

  useEffect(() => {
    props.getEntity(props.match.params.id);
    props.getVillages();
    props.getAllFacility();
  }, []);
  const getHfName = (id, hfList) => {
 
    const hf = hfList.find(v => v.id === id);
    return !hf ?
      { short:'', full: '',council:'',district:''}
      :
      {
        short: hf.name,
        council:  hf?.council?.name,
        district:  hf?.council?.parent?.name,
        full: (hf.name + ' / ' + hf?.council?.name + ' / ' + hf?.council?.parent?.name)
      };
  }
  const { driverEntity } = props;
  
  // Get vehicle type in correct language based on currentLocale
  const getVehicleType = () => {
    return currentLocale === 'st' && driverEntity.vehicleType?.stType 
      ? driverEntity.vehicleType?.stType 
      : driverEntity.vehicleType?.enType;
  };
  
  return (
    <Row>
      <Col md="8">
        <h2>
          {t('driver.detail.title')} [<b>{driverEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>{t('common.fields.firstName')}</dt>
          <dd>{driverEntity.firstName}</dd>
          <dt>{t('common.fields.lastName')}</dt>
          <dd>{driverEntity.lastName}</dd>
          <dt>{t('common.fields.createdDate')}</dt>
          <dd>{convertDateTimeFromServer(driverEntity.createdDate)}</dd>
          <dt>{t('common.fields.vehicleType')}</dt>
          <dd>{getVehicleType()}</dd>
          <dt>{t('common.fields.phoneNumber')}</dt>
          <dd>{driverEntity.phoneNumber}</dd>
          <dt>{t('driver.fields.nationalId')}</dt>
          <dd>{driverEntity.nationalId}</dd>
          <dt>{t('common.fields.birthDate')}</dt>
          <dd>{driverEntity.birthDate}</dd>
          <dt>{t('driver.fields.licenseNumber')}</dt>
          <dd>{driverEntity.licenseNumber}</dd>
          <dt>{t('driver.fields.licenseIssueDate')}</dt>
          <dd>{driverEntity.licenseIssueDate}</dd>
          <dt>{t('driver.fields.licenseExpirationDate')}</dt>
          <dd>{driverEntity.licenseExpirationDate}</dd>
          <dt>{t('common.fields.mpesaNumber')}</dt>
          <dd>{driverEntity.mpesaNumber}</dd>
          <dt>{t('driver.fields.vehicleOwner')}</dt>
          <dd>{driverEntity.ownerFirstName}&nbsp;{driverEntity.ownerLastName}&nbsp;{driverEntity.ownerPhoneNumber}</dd>
          <dt>
            <span id="phoneNumber2">{t('driver.fields.phoneNumber2')}</span>
          </dt>
          <dd>{driverEntity.phone_number_2}</dd>
          <dt>
            <span id="phoneNumber3">{t('driver.fields.phoneNumber3')}</span>
          </dt>
          <dd>{driverEntity.phone_number_3}</dd>
          <dt>{t('common.fields.comments')}</dt>
          <dd>{driverEntity.comments}</dd>
          <dt>{t('driver.fields.homeHealthcareFacility')}</dt>
          <dd>{driverEntity.homeHealthcareFacilityId ? getHfName(driverEntity.homeHealthcareFacilityId, props.allHealthfacility).full : ''}</dd>

          <dt>{t('driver.fields.homeVillage')}</dt>
          <dd>{driverEntity.homeVillageId ? getVillageName(driverEntity.homeVillageId, villages).full : ''}</dd>

          <dt>{t('driver.fields.neighboringVillages')}</dt>
          { !driverEntity?.neighborVillageIds ||
            driverEntity.neighborVillageIds.map(id => <dd key={id}>{ getVillageName(id, villages).full }</dd>) }

          <dt>{t('driver.fields.neighboringHealthcareFacilities')}</dt>
          { !driverEntity?.neighborHealthcareFacilityIds ||
            driverEntity.neighborHealthcareFacilityIds.map(id => <dd key={id}>{ getVillageName(id, props.allHealthfacility).full }</dd>) }
        </dl>
        <Button tag={Link} to="/driver" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">{t('common.actions.back')}</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/driver/${driverEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">{t('common.actions.edit')}</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  driverEntity: storeState.driver.entity,
  villages: storeState.village.entities,
  allHealthfacility: storeState.healthcareFacility.allFacility,
  currentLocale: storeState.locale.currentLocale
});

const mapDispatchToProps = {
  getEntity,
  getVillages,
  getAllFacility
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(DriverDetail);
